/** The version key within the manifest */
export const currentVersionKey = 'v1';

/** The ODSP driver manifest format. Very basic for now, but could eventually be expanded (e.g., to specify assets to preload, etc.) */
export type OdspDriverManifest = { jsBaseUrl: string; [currentVersionKey]: { index: string } };

export const ManifestUrlSuffixRelativeToBaseCdnPath = '/odsp-driver/versionless/deploymentManifestOdspDriver.json';

export type OdspDriverManifestEnvironment = 'Prod' | 'Dogfood' | 'Staging' | 'Gcc' | undefined;
